/* ==========================================================================
   Cart offers — adds the chosen free gift to the cart.
   The progress numbers themselves are rendered by Liquid, so they stay
   correct on every Dawn section re-render without any JS bookkeeping.
   ========================================================================== */
(function () {
  'use strict';

  // The snippet renders in both the cart drawer and the cart page, so this
  // file can be included twice on one document. Register the handler once.
  if (window.__cartOffersInit) return;
  window.__cartOffersInit = true;

  var ADDING = false;

  // The cart template names its sections 'cart-items' and 'cart-footer',
  // not 'main-cart-items' / 'main-cart-footer' — those are the DOM ids. Ask
  // by the wrong name and Shopify renders the section file standalone,
  // without the template's blocks, so the subtotal block (and the
  // .js-contents inside it) simply is not there. dataset.id carries the
  // real name, exactly as Dawn's own cart JS reads it.
  function cartPageSections() {
    var out = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (domId) {
      var el = document.getElementById(domId);
      if (el && el.dataset.id) out.push({ domId: domId, section: el.dataset.id });
    });
    return out;
  }

  function sectionsToUpdate() {
    // Ask Shopify to re-render whichever cart sections exist on this page.
    var ids = [];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer', 'cart-icon-bubble');
    cartPageSections().forEach(function (s) {
      ids.push(s.section);
    });
    return ids;
  }

  // The cart page has no client-side renderer of its own, and the drawer
  // exists on every page — so without this the drawer would quietly absorb
  // the update while the cart page kept showing stale numbers.
  function renderCartPage(parsedState) {
    if (!document.getElementById('main-cart-items')) return false;
    if (!parsedState || !parsedState.sections) return false;
    var updated = {};
    var wanted = cartPageSections();
    wanted.forEach(function (entry) {
      var html = parsedState.sections[entry.section];
      var host = document.getElementById(entry.domId);
      if (!html || !host) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var freshHost = parsed.querySelector('#' + entry.domId) || parsed;
      // The footer renders one .js-contents per block, so replace them
      // pairwise rather than only the first.
      var fresh = freshHost.querySelectorAll('.js-contents');
      var targets = host.querySelectorAll('.js-contents');
      if (!fresh.length || fresh.length !== targets.length) return;
      for (var i = 0; i < targets.length; i++) {
        targets[i].innerHTML = fresh[i].innerHTML;
      }
      updated[entry.domId] = true;
    });
    // Emptying the cart from the page has to swap in the empty state, which
    // Dawn keys off an is-empty class outside the re-rendered parts.
    if (typeof parsedState.item_count === 'number') {
      var none = parsedState.item_count === 0;
      var itemsHost = document.querySelector('cart-items');
      var footerHost = document.getElementById('main-cart-footer');
      if (itemsHost) itemsHost.classList.toggle('is-empty', none);
      if (footerHost) footerHost.classList.toggle('is-empty', none);
    }
    var bubbleHTML = parsedState.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHTML && bubble) {
      var b = new DOMParser().parseFromString(bubbleHTML, 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    // Rows without the total would leave the two disagreeing, so treat a
    // partial refresh as a failure and let the caller reload instead.
    return wanted.length > 0 && wanted.every(function (entry) {
      return updated[entry.domId];
    });
  }

  function refreshCart(parsedState) {
    var openDrawer = document.querySelector('cart-drawer.active');

    // The cart page behind an open drawer still gets refreshed, but it never
    // decides the outcome: a failed patch there would reload the page out
    // from under the drawer, which reads as the cart randomly navigating.
    if (document.getElementById('main-cart-items')) {
      var pageOk = renderCartPage(parsedState);
      if (!openDrawer) return pageOk;
    }
    // Reuse Dawn's own renderers where available so the drawer stays in sync.
    var drawer = document.querySelector('cart-drawer');
    var items = document.querySelector('cart-items');
    var target = drawer || items;
    if (!target || typeof target.renderContents !== 'function' || !parsedState || !parsedState.sections) return false;

    // Re-rendering replaces the drawer markup and can drop its open state.
    var wasOpen = !!(drawer && drawer.classList.contains('active'));
    // Dawn expects the full add.js payload, not just the sections map.
    target.renderContents(parsedState);
    if (wasOpen && drawer && typeof drawer.open === 'function') {
      requestAnimationFrame(function () {
        if (!drawer.classList.contains('active')) drawer.open();
      });
    }
    return true;
  }

  function addLine(button, asGift) {
    if (ADDING) return;
    var id = button.getAttribute('data-variant-id');
    if (!id) return;

    ADDING = true;
    button.disabled = true;
    var card = button.closest('.cart-offer__gift') || button.closest('.cart-reco__card');
    if (card) card.classList.add('is-adding');

    var line = { id: parseInt(id, 10), quantity: 1 };
    if (asGift) line.properties = { _free_gift: 'true' };

    var body = {
      items: [line],
      sections: sectionsToUpdate().join(','),
      sections_url: window.location.pathname
    };

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || 'Could not add gift');
        if (!refreshCart(r.data)) window.location.reload();
      })
      .catch(function (err) {
        // Never hard-reload on failure: it closes the drawer and loses context.
        console.error('[cart-offers] add to cart failed:', err);
        button.disabled = false;
        if (card) card.classList.remove('is-adding');
      })
      .finally(function () {
        ADDING = false;
      });
  }

  /* ------------------------------------------------------------------
     Coupon codes. Shopify has no storefront API for applying a code to
     the cart, so use the discount link endpoint: it stores the code on
     the session and sends the shopper back where they were.
     ------------------------------------------------------------------ */
  function applyCoupon(code) {
    var clean = (code || '').trim();
    if (!clean) return;
    var back = window.location.pathname + window.location.search;
    window.location.href =
      '/discount/' + encodeURIComponent(clean) + '?redirect=' + encodeURIComponent(back);
  }

  /* ------------------------------------------------------------------
     Recommendation slider dots. Rebuilt whenever Dawn re-renders the
     cart, since that replaces the slider markup.
     ------------------------------------------------------------------ */
  function pageCount(scroller) {
    if (!scroller.clientWidth) return 0;
    return Math.ceil((scroller.scrollWidth - 4) / scroller.clientWidth);
  }

  function buildDots(reco) {
    var scroller = reco.querySelector('[data-reco-scroller]');
    var dots = reco.querySelector('[data-reco-dots]');
    if (!scroller || !dots) return;

    var pages = pageCount(scroller);
    if (pages < 2) {
      dots.innerHTML = '';
      return;
    }

    dots.innerHTML = '';
    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cart-reco__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-page', String(i));
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dots.appendChild(dot);
    }

    function sync() {
      var active = Math.round(scroller.scrollLeft / scroller.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-active', i === active);
      });
    }

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        sync();
      });
    });

    dots.addEventListener('click', function (evt) {
      var dot = evt.target.closest('.cart-reco__dot');
      if (!dot) return;
      scroller.scrollTo({
        left: parseInt(dot.getAttribute('data-page'), 10) * scroller.clientWidth,
        behavior: 'smooth'
      });
    });
  }

  var dotsQueued = false;
  function initRecoDots() {
    if (dotsQueued) return;
    dotsQueued = true;
    requestAnimationFrame(function () {
      dotsQueued = false;
      document.querySelectorAll('[data-cart-reco]').forEach(function (reco) {
        if (reco.dataset.dotsReady === '1') return;
        reco.dataset.dotsReady = '1';
        buildDots(reco);
      });
    });
  }

  // Anything that can change the cart re-runs both housekeeping passes.
  // revokeGift() is deliberately outside the rAF: a backgrounded tab never
  // fires one, and the gift still has to come out of the cart.
  /* ------------------------------------------------------------------
     Dawn re-renders the whole drawer on every quantity change, which
     throws away the scroll position of the region holding the item rows.
     Keep the last position and put it back on the replacement node.
     ------------------------------------------------------------------ */
  var savedScroll = 0;

  function keepScrollPosition() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('active')) {
      // Opening the drawer fresh should start at the top.
      savedScroll = 0;
      return;
    }

    var el = document.querySelector('#CartDrawer .cd-scroll');
    if (!el || el.dataset.scrollBound === '1') return;
    el.dataset.scrollBound = '1';
    el.addEventListener(
      'scroll',
      function () {
        savedScroll = el.scrollTop;
      },
      { passive: true }
    );

    if (!savedScroll) return;

    // This node is the replacement, so restore what the old one had. The
    // first frames can still be short — images below have not laid out yet
    // — so a single assignment gets clamped to 0. Keep trying briefly.
    var want = savedScroll;
    var tries = 0;
    (function restore() {
      el.scrollTop = want;
      tries += 1;
      if (el.scrollTop < want && tries < 12) requestAnimationFrame(restore);
    })();
  }

  function onCartChanged() {
    keepScrollPosition();
    initRecoDots();
    revokeGift();
    claimGift();
  }

  /* ------------------------------------------------------------------
     Free gift housekeeping. The gift only exists while the cart is over
     the threshold, so when Liquid re-renders the offer bar with a
     revoke marker, take the line back out.
     ------------------------------------------------------------------ */
  var REVOKING = false;
  var revokeFailures = 0;

  function revokeGift() {
    if (REVOKING || revokeFailures >= 3) return;
    var marker = document.querySelector('[data-cart-offer][data-gift-revoke]');
    if (!marker) return;
    var key = marker.getAttribute('data-gift-revoke');
    if (!key) return;

    REVOKING = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0,
        sections: sectionsToUpdate().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('could not remove the free gift');
        revokeFailures = 0;
        // Strip every marker first: a failed re-render must not re-trigger us.
        document.querySelectorAll('[data-gift-revoke]').forEach(function (el) {
          el.removeAttribute('data-gift-revoke');
        });
        // The cart page has no client-side renderer, so refresh it outright.
        if (!refreshCart(r.data) && document.getElementById('main-cart-items')) {
          window.location.reload();
        }
      })
      .catch(function (err) {
        revokeFailures += 1;
        console.error('[cart-offers] free gift removal failed:', err);
      })
      .finally(function () {
        REVOKING = false;
      });
  }

  var CLAIMING = false;
  var claimFailures = 0;

  // Mirror image of revokeGift: the cart qualifies, so put the gift in.
  function claimGift() {
    if (CLAIMING || ADDING || claimFailures >= 3) return;
    var marker = document.querySelector('[data-gift-autoadd]');
    if (!marker) return;
    var id = parseInt(marker.getAttribute('data-gift-autoadd'), 10);
    if (!id) return;

    CLAIMING = true;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1, properties: { _free_gift: 'true' } }],
        sections: sectionsToUpdate().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error(r.data.description || 'could not add the free gift');
        claimFailures = 0;
        document.querySelectorAll('[data-gift-autoadd]').forEach(function (el) {
          el.removeAttribute('data-gift-autoadd');
        });
        if (!refreshCart(r.data) && document.getElementById('main-cart-items')) {
          window.location.reload();
        }
      })
      .catch(function (err) {
        claimFailures += 1;
        console.error('[cart-offers] free gift could not be added:', err);
      })
      .finally(function () {
        CLAIMING = false;
      });
  }

  /* ------------------------------------------------------------------
     Cart quantities are changed by VARIANT, not by line.

     A discount that covers only part of a line makes Shopify split that
     line, so one perfume can sit on two or three of them. Dawn addresses
     lines by index, so after a split it reads the wrong line, reports
     "you can only add N of this item" for a change that did work, and
     leaves the same perfume showing twice. /cart/update.js takes a
     variant id and a total, which survives any amount of splitting.
     ------------------------------------------------------------------ */
  var UPDATING = false;

  function variantTotal(cart, variantId) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === variantId && !(item.properties && item.properties._free_gift)) {
        total += item.quantity;
      }
    });
    return total;
  }

  function setVariantQuantity(variantId, quantity, row) {
    if (UPDATING) return;
    UPDATING = true;
    if (row) row.classList.add('is-busy');

    // update.js keyed by VARIANT sets that quantity on every line holding
    // the variant, so a split line silently doubles it. Keyed by line item
    // key it addresses one line each: the whole amount goes on the first,
    // the rest are cleared, and Shopify re-splits as the discount requires.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var updates = {};
        var first = true;
        cart.items.forEach(function (item) {
          if (item.variant_id !== variantId) return;
          if (item.properties && item.properties._free_gift) return;
          updates[item.key] = first ? Math.max(0, quantity) : 0;
          first = false;
        });
        if (first) throw new Error('no cart line for that variant');

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sectionsToUpdate().join(','),
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || 'could not update the cart');
        if (!refreshCart(r.data)) window.location.reload();
      })
      .catch(function (err) {
        console.error('[cart-offers] quantity update failed:', err);
        if (row) row.classList.remove('is-busy');
      })
      .finally(function () {
        UPDATING = false;
      });
  }

  document.addEventListener(
    'click',
    function (evt) {
      var btn = evt.target.closest('.quantity__button, cart-remove-button button, cart-remove-button a');
      if (!btn) return;
      var row = btn.closest('.cart-item');
      if (!row) return; // product page steppers are Dawn's business
      var input = row.querySelector('.quantity__input');
      if (!input) return;
      var variantId = parseInt(input.getAttribute('data-quantity-variant-id'), 10);
      if (!variantId) return;

      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      // Read the cart's own count, not the input: Dawn's stepper may have
      // already nudged the field before this handler saw the click.
      var known = parseInt(input.getAttribute('data-cart-quantity'), 10);
      var current = isNaN(known) ? parseInt(input.value, 10) || 0 : known;
      var next;
      if (btn.closest('cart-remove-button')) {
        next = 0;
      } else if (btn.getAttribute('name') === 'plus') {
        next = current + (parseInt(input.getAttribute('step'), 10) || 1);
      } else {
        // Stepping down from 1 takes the perfume out rather than doing
        // nothing at the input's minimum.
        next = current - (parseInt(input.getAttribute('step'), 10) || 1);
        if (next < 1) next = 0;
      }
      setVariantQuantity(variantId, next, row);
    },
    true
  );

  // Typing a quantity straight into the field goes the same route.
  document.addEventListener(
    'change',
    function (evt) {
      var input = evt.target.closest('.cart-item .quantity__input');
      if (!input) return;
      var variantId = parseInt(input.getAttribute('data-quantity-variant-id'), 10);
      if (!variantId) return;
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      // Only a real edit counts. Re-rendering the drawer makes Dawn fire
      // change events of its own, and acting on those re-sent whatever the
      // field happened to hold.
      var wanted = parseInt(input.value, 10);
      var known = parseInt(input.getAttribute('data-cart-quantity'), 10);
      if (isNaN(wanted) || wanted === known) return;
      setVariantQuantity(variantId, wanted, input.closest('.cart-item'));
    },
    true
  );

  document.addEventListener('click', function (evt) {
    var gift = evt.target.closest('[data-gift-add]');
    if (gift) {
      evt.preventDefault();
      addLine(gift, true);
      return;
    }
    var add = evt.target.closest('[data-cart-add]');
    if (add) {
      evt.preventDefault();
      addLine(add, false);
      return;
    }
    var apply = evt.target.closest('[data-coupon-apply]');
    if (apply) {
      evt.preventDefault();
      var box = apply.closest('.cd-coupon') || document;
      var input = box.querySelector('[data-coupon-input]');
      if (!input || !input.value.trim()) {
        if (box.classList) box.classList.add('is-invalid');
        if (input) input.focus();
        return;
      }
      apply.disabled = true;
      applyCoupon(input.value);
    }
  });

  document.addEventListener('change', function (evt) {
    var check = evt.target.closest('[data-coupon-code]');
    if (check && check.checked) applyCoupon(check.getAttribute('data-coupon-code'));
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Enter') return;
    var input = evt.target.closest('[data-coupon-input]');
    if (!input) return;
    evt.preventDefault();
    applyCoupon(input.value);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onCartChanged);
  } else {
    onCartChanged();
  }
  window.addEventListener('load', onCartChanged);

  // A link ending in #bag opens the bag on arrival (ads, WhatsApp follow-ups).
  window.addEventListener('load', function () {
    if (window.location.hash !== '#bag') return;
    var bag = document.querySelector('cart-drawer');
    if (bag && typeof bag.open === 'function') bag.open();
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-cart-reco]').forEach(function (reco) {
      reco.dataset.dotsReady = '';
    });
    initRecoDots();
  });
  // Watch only the cart containers Dawn re-renders, not the whole document.
  var watched = ['cart-drawer', '#main-cart-items', '.cart-page__reco']
    .map(function (sel) { return document.querySelector(sel); })
    .filter(Boolean);
  if (!watched.length) watched = [document.body];
  watched.forEach(function (node) {
    new MutationObserver(onCartChanged).observe(node, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  });
})();
